var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('AboveTheFold'),_c('AboutMe'),_c('Clara'),_c('PadelPlus'),_c('PokerPower'),_c('BlockwareSolutions'),_c('TheSill'),_c('Dxos'),_c('XubioSalaries'),_c('XubioGeneral'),_c('XubioLibraries'),_c('XubioMobileApp'),_c('DollarNotifier'),_c('PausaWeb'),_c('PausaApp'),_c('AnimaEdu'),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }